import PropTypes from 'prop-types';

const allowedRenderLocations = ['top', 'bottom', 'both'];
const allowedColumnTextAligns = ['left', 'center', 'right'];
const allowedCellVerticalAligns = ['top', 'middle', 'bottom'];
const allowedLanguages = ['en', 'da'];
const allowedFilterOptionTypes = [PropTypes.string, PropTypes.object];
const allowedColumnValueTypes = ['object', 'boolean', 'number', 'string', 'undefined'];

const allowedTableDataShape = {
  dataLabel: PropTypes.string.isRequired, // TODO: Get rid off this premature and overcomplicated optimization
  dataToProcess: PropTypes.arrayOf(PropTypes.object).isRequired,
  preprocessData: PropTypes.func
};

const allowedCellContentTypes = [
  PropTypes.element,
  PropTypes.string,
  PropTypes.number,
  PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.array
    ])
  )
];

const allowedPaginationProps = {
  columnCount: PropTypes.number.isRequired,
  rowCount: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  pageNumber: PropTypes.number.isRequired,
  goToPageNumber: PropTypes.func.isRequired,
  languageCode: PropTypes.oneOf(allowedLanguages),
  refParentTable: PropTypes.object
};

const allowedTablePartProps = {
  isDataReady: PropTypes.bool,
  paginationData: PropTypes.shape({
    columnCount: PropTypes.number.isRequired,
    rowCount: PropTypes.number.isRequired,
    pageNumber: PropTypes.number.isRequired,
    goToPageNumber: PropTypes.func.isRequired
  })
};

const sharedFilterProps = {
  renderOptionLabel: PropTypes.func,
  filterOptions: PropTypes.arrayOf(
    PropTypes.oneOfType(allowedFilterOptionTypes)
  ).isRequired
};

const allowedFilterContentProps = {
  ...sharedFilterProps,
  filteredColumnId: PropTypes.string.isRequired,
  filteredColumnTitle: PropTypes.string.isRequired,
  placeholderContent: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.element.isRequired
  ]),
  languageCode: PropTypes.oneOf(allowedLanguages)
};

const allowedFilterDataPropTypes = {
  ...sharedFilterProps,
  filterData: PropTypes.func.isRequired
};

const allowedDataDefinitionListProps = {
  listData: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(
      PropTypes.object
    )
  ]).isRequired,
  classNames: PropTypes.arrayOf(PropTypes.string),
  cellVerticalAlign: PropTypes.oneOf(allowedCellVerticalAligns),
  preprocessDefinitionTerms: PropTypes.func,
  preprocessNestingTerms: PropTypes.func,
  preprocessDefinitionDescriptions: PropTypes.func,
  hasWideDescriptions: PropTypes.bool
};

const allowedTranslationLabelProps = {
  tableBody: PropTypes.shape({
    noResult: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
  })
};

const allowedTableColumnPropTypes = {
  columnId: PropTypes.string.isRequired,
  columnHeadingContent: PropTypes.oneOfType(allowedCellContentTypes),
  isGroupColumn: PropTypes.bool,
  valueType: PropTypes.oneOf(allowedColumnValueTypes)
};

const allowedTableCellPropTypes = {
  columnHeadingContent: PropTypes.oneOfType(allowedCellContentTypes),
  cellContent: PropTypes.oneOfType(allowedCellContentTypes),
  firstRowIndex: PropTypes.number.isRequired,
  isNestedCell: PropTypes.bool.isRequired,
  spannedRows: PropTypes.number,
  nestedCells: PropTypes.arrayOf(PropTypes.array)
};

const allowedTableItemPropTypes = {
  itemRowsLen: PropTypes.number.isRequired,
  tableItemCells: PropTypes.arrayOf(
    PropTypes.shape({
      columnId: PropTypes.string.isRequired,
      ...allowedTableCellPropTypes
    })
  )
};

export {
  allowedTableDataShape,
  allowedTableColumnPropTypes,
  allowedTableItemPropTypes,
  allowedTableCellPropTypes,
  allowedRenderLocations,
  allowedColumnTextAligns,
  allowedCellVerticalAligns,
  allowedLanguages,
  allowedFilterOptionTypes,
  allowedFilterDataPropTypes,
  allowedFilterContentProps,
  allowedColumnValueTypes,
  allowedCellContentTypes,
  allowedPaginationProps,
  allowedTablePartProps,
  allowedDataDefinitionListProps,
  allowedTranslationLabelProps
};